var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-justify-center tw-items-center"},[_c('div',{staticClass:"tw-animate-spin tw-rounded-full tw-border-2 tw-border-r-transparent",class:_vm.borderClass,style:({ width: `${_vm.size}px`, height: `${_vm.size}px` })})])
}
var staticRenderFns = []

export { render, staticRenderFns }